/**
 * The Id used to identify the main App routes
 */
export const APP_FEATURE_GROUP_ID = "APP_FEATURE_GROUP_ID";

/**
 * The prefix used to identify params in an Angular Route's path;
 */
export const NG_ROUTE_PARAM_PREFIX = ":";

/**
 * Regex to match a parameter from an Angular Route's path
 * i.e ":id" will match and the param group will be "id"
 */
export const NG_ROUTE_PARAM_REGEX = new RegExp(`^${NG_ROUTE_PARAM_PREFIX}(?<param>[a-zA-Z0-9_-]+)$`);

/**
 * The character used to divide an Angular Route's path
 */
export const NG_ROUTE_PATH_DIVIDER = "/";

/**
 * This is the first Angular Navigation Command to use to force navigation from the Angular Router's Root
 *
 */
export const NG_ROUTER_ROOT_COMMAND = NG_ROUTE_PATH_DIVIDER;
